import styled from 'styled-components';
import { mediaQueries } from '@fourthwall/components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-500);
`;
export const Grid = styled.div `
  display: grid;
  gap: var(--space-500);
  width: 100%;
  min-width: 0;
  grid-template-columns: repeat(1, minmax(0, 1fr));

  ${mediaQueries.tablet} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: 1480px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;
export const ItemContainer = styled.div `
  min-width: 0; // vertical scrolling fix

  ${mediaQueries.tablet} {
    display: flex;
  }
`;
